/*
 *
 *  * (C) Copyright 2006-2020 hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * All Rights Reserved.
 *  *
 *  * These materials are unpublished, proprietary, confidential source code of
 *  * hSenid Mobile Solutions (Pvt) Limited and constitute a TRADE SECRET
 *  * of hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * hSenid Mobile Solutions (Pvt) Limited retains all title to and intellectual
 *  * property rights in these materials.
 *  *
 *
 */

import React from "react";

interface DropdownValues {
  label: string;
  value: string;
}

interface DropdownProps {
  className: string;
  title: string;
  value: string;
  options: DropdownValues[];
  handleChange(s: string): void;
}

function HmsDropdown({
  className,
  title,
  value,
  options,
  handleChange,
}: DropdownProps) {
  return (
    <div>
      <label>{title}</label>
      <select
        className={className}
        value={value}
        onChange={(e) => {
          handleChange(e.target.value);
        }}
      >
        {options.map((item) => (
          <option key={item.value} value={item.value}>
            {item.label}
          </option>
        ))}
      </select>
    </div>
  );
}

export default HmsDropdown;
